import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { PublicLayout } from '../layouts/PublicLayout.jsx';
import { AdminLayout } from '../layouts/AdminLayout.jsx';
import { HomePage } from '../pages/HomePage.jsx';
import { CatalogPage } from '../pages/CatalogPage.jsx';
import { ProductDetailPage } from '../pages/ProductDetailPage.jsx';
import { OrderTrackingPage } from '../pages/OrderTrackingPage.jsx';
import { ContactPage } from '../pages/ContactPage.jsx';
import { AdminDashboardPage } from '../pages/AdminDashboardPage.jsx';
import { AdminLoginPage } from '../pages/AdminLoginPage.jsx';
import { AdminOrdersPage } from '../pages/AdminOrdersPage.jsx';
import { AdminOrderDetailPage } from '../pages/AdminOrderDetailPage.jsx';
import { AdminProductsPage } from '../pages/AdminProductsPage.jsx';
import { AdminAuditPage } from '../pages/AdminAuditPage.jsx';
import { AdminAccountsPage } from '../pages/AdminAccountsPage.jsx';
import { NotFoundPage } from '../pages/NotFoundPage.jsx';
import { LegalPage } from '../pages/LegalPage.jsx';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'catalogue', element: <CatalogPage /> },
      { path: 'produit/:slug', element: <ProductDetailPage /> },
      { path: 'suivi', element: <OrderTrackingPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'politique-confidentialite', element: <LegalPage documentType="privacy" /> },
      { path: 'conditions-utilisation', element: <LegalPage documentType="terms" /> },
      { path: 'suppression-donnees', element: <LegalPage documentType="deletion" /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  {
    path: '/admin/connexion', element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: 'commandes', element: <AdminOrdersPage /> },
      { path: 'commandes/:id', element: <AdminOrderDetailPage /> },
      { path: 'produits', element: <AdminProductsPage /> },
      { path: 'historique', element: <AdminAuditPage /> },
      { path: 'comptes', element: <AdminAccountsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
